module.exports = __webpack_public_path__ + "static/media/hh-splash-screen.de035198.jpg";